namespace appn.tour {
    export interface TourOptions {
        target: JQuery;
        title: string;
        message: string;
        step: number;
        totalSteps: number;
        showBack?: boolean;
        onNext: () => void;
        onBack?: () => void;
        targets?: JQuery;
        delayBeforeShow?: number;
        scrollIntoView?: boolean;
        placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
    }

    let _scrollHandler: (() => void) | null = null;
    let _resizeHandler: (() => void) | null = null;
    let _$singleTarget: JQuery | null = null;
    let _$mergedTargets: JQuery | null = null;

    export function show(options: TourOptions): void {
        // Remove current tour step if any
        hide();

        if (options.targets && options.targets.length > 0) {
            _$mergedTargets = options.targets;
            _$singleTarget = options.target.first();
        } else
            _$singleTarget = options.target.first();
        

        if (_$singleTarget.length === 0)
            return;        

        let $spotlight = $('#tour-spotlight');
        if ($spotlight.length === 0)
            $spotlight = $('<div id="tour-spotlight"></div>').appendTo('body');

        const showTourAfterDelay = () => {
            if (!_$singleTarget || _$singleTarget.length === 0)
                return;
            
            if (_$mergedTargets && _$mergedTargets.length > 0) {
                positionSpotlightForMultiple($spotlight, _$mergedTargets);
                setupPositionListenersForMultiple($spotlight, _$mergedTargets);
            } else {
                positionSpotlight($spotlight, _$singleTarget);
                setupPositionListeners($spotlight, _$singleTarget);
            }

            const backBtn = options.showBack !== false ? `<button class="btn btn-sm btn-secondary tour-back mr-1">${T("Back")}</button>` : '';

            const content = `
            <div class="tour-content">
                <p>${options.message}</p>
                <div class="d-flex align-items-center justify-content-between mt-3">
                    <small class="text-muted">${T("Step {0} of {1}", options.step, options.totalSteps)}</small>
                    <div class="tour-buttons">
                        ${backBtn}
                        <button class="btn btn-sm btn-success tour-next">${T("Next")}</button>
                    </div>
                </div>
            </div>`;

            (_$singleTarget as any).popover('dispose');

            (_$singleTarget as any).popover({
                title: `<strong>${options.title}</strong>`,
                content: content,
                html: true,
                sanitize: false,
                placement: options.placement || 'right',
                container: 'body',
                boundary: 'viewport',
                offset: '0, 10',
                trigger: 'manual',
                template: '<div class="popover tour-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
            }).popover('show');

            if (options.scrollIntoView !== false && _$singleTarget.length > 0)
                _$singleTarget[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

            const $nextBtn = $('.tour-popover .tour-next');
            const $backBtn = $('.tour-popover .tour-back');

            $nextBtn.off('.appnTour').on('click.appnTour', (e) => {
                e.preventDefault();
                e.stopPropagation();
                options.onNext();
            });

            if ($backBtn.length > 0 && options.showBack !== false) {
                $backBtn.off('.appnTour').on('click.appnTour', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    options.onBack?.();
                });
            }
        };

        const delay = options.delayBeforeShow !== undefined ? options.delayBeforeShow : 0;
        setTimeout(showTourAfterDelay, delay);
    }

    export function hide(): void {
        const $popovers = $('.tour-popover');
        const $spotlight = $('#tour-spotlight');
        
        $popovers.each(function() {
            $(this).popover('dispose');
        });
        
        if ($spotlight.length > 0)
            $spotlight.css({ width: 0, height: 0, opacity: 0 });
        
        removePositionListeners();

        _$singleTarget = null;
        _$mergedTargets = null;
    }

    function positionSpotlight($spotlight: JQuery, $target: JQuery): void {
        if ($target.length === 0) 
            return;

        const rect = $target[0].getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        $spotlight.css({
            position: 'absolute',
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
            width: rect.width,
            height: rect.height,
            opacity: 1,
            transition: 'all 0.3s ease'
        });
    }

    function positionSpotlightForMultiple($spotlight: JQuery, $targets: JQuery): void {
        if ($targets.length === 0) 
            return;

        let top = Infinity, left = Infinity;
        let bottom = -Infinity, right = -Infinity;

        $targets.each(function() {
            const rect = this.getBoundingClientRect();
            top = Math.min(top, rect.top);
            left = Math.min(left, rect.left);
            bottom = Math.max(bottom, rect.bottom);
            right = Math.max(right, rect.right);
        });

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        $spotlight.css({
            position: 'absolute',
            top: top + scrollTop,
            left: left + scrollLeft,
            width: right - left,
            height: bottom - top,
            opacity: 1,
            transition: 'all 0.3s ease'
        });
    }

    function setupPositionListeners($spotlight: JQuery, $target: JQuery): void {
        _scrollHandler = () => positionSpotlight($spotlight, $target);
        _resizeHandler = () => positionSpotlight($spotlight, $target);

        $(window).on('scroll.appnTour', _scrollHandler);
        $(window).on('resize.appnTour', _resizeHandler);
    }

    function setupPositionListenersForMultiple($spotlight: JQuery, $targets: JQuery): void {
        _scrollHandler = () => positionSpotlightForMultiple($spotlight, $targets);
        _resizeHandler = () => positionSpotlightForMultiple($spotlight, $targets);

        $(window).on('scroll.appnTour', _scrollHandler);
        $(window).on('resize.appnTour', _resizeHandler);
    }

    function removePositionListeners(): void {
        if (_scrollHandler) {
            $(window).off('scroll.appnTour', _scrollHandler);
            _scrollHandler = null;
        }
        if (_resizeHandler) {
            $(window).off('resize.appnTour', _resizeHandler);
            _resizeHandler = null;
        }
    }
}
